import { useMediaQuery } from "@material-ui/core";
import { get } from "lodash";
import React from "react";
import {
	ArrayField,
	ChipField,
	DateField,
	EditButton,
	EmailField,
	List as RaList,
	NumberField,
	SingleFieldList,
	TextField,
	useTranslate,
} from "react-admin";
import ResponsiveList from "../components/lists/ResponsiveList";
import { useListStyles, useSelector } from "../components/lists/useStyles";
import perPage from "../utils/per-page";
import Actions from "./Actions";
import StatusField from "./fields/StatusField";
import Filters from "./Filters";
import LoginButton from "./LoginButton";

const Datagrid = ({ permissions, ...props }) => {
	const xl = useMediaQuery((theme) => theme.breakpoints.up("xl"));
	const hasChildrenFilter = get(props, "filterValues.has_children");
	const translate = useTranslate();
	return (
		<ResponsiveList
			{...props}
			mobileHeader={
				<React.Fragment>
					<TextField
						source="name"
						label="resources.users.fields.profile.name"
						style={{ fontWeight: "bold" }}
						variant="subtitle1"
					/>
					<EditButton />
				</React.Fragment>
			}
			mobileBody={
				<React.Fragment>
					<DateField source="created" showTime color="textSecondary" />
					<DateField
						source="last_login"
						showTime
						color="textSecondary"
						emptyText={translate("ra.page.empty")}
					/>
					<StatusField source="status" />
					<ArrayField source="roles" sortable={false}>
						<SingleFieldList>
							<ChipField source="name" />
						</SingleFieldList>
					</ArrayField>
				</React.Fragment>
			}
			mobileActions={
				<React.Fragment>
					{permissions && permissions("admin") && <LoginButton />}
				</React.Fragment>
			}
		>
			<TextField source="id" label="ID" style={{ fontWeight: "bold" }} />
			<TextField
				source="profile.name"
				sortBy="UserProfiles.name"
				style={{ fontWeight: "bold" }}
			/>
			<TextField
				source="profile.surname"
				sortBy="UserProfiles.surname"
				style={{ fontWeight: "bold" }}
			/>
			<TextField
				source="profile.phone"
				sortBy="UserProfiles.phone"
			/>
			<EmailField source="email" />
			{hasChildrenFilter && (
				<NumberField source="count_children" sortable={false} />
			)}
			<DateField source="created" showTime />
			<DateField source="last_login" showTime />
			<StatusField source="status" />
			{xl && (
				<ArrayField source="groups" sortable={false}>
					<SingleFieldList>
						<ChipField source="name" />
					</SingleFieldList>
				</ArrayField>
			)}
			<ArrayField source="roles" sortable={false}>
				<SingleFieldList>
					<ChipField source="name" />
				</SingleFieldList>
			</ArrayField>
			{permissions && permissions("admin") && <LoginButton />}
			<EditButton />
		</ResponsiveList>
	);
};

const List = (props) => {
	const sidebarOpen = useSelector((state) => state.admin.ui.sidebarOpen);
	const classes = useListStyles({ sidebarOpen });
	return (
		<RaList
			{...props}
			actions={<Actions permissions={props.permissions} />}
			classes={classes}
			perPage={perPage(50, 25)}
			filters={<Filters permissions={props.permissions} />}
			sort={{ field: "created", order: "DESC" }}
			bulkActionButtons={props.permissions && props.permissions("admin") ? undefined : false}
		>
			<Datagrid {...props} />
		</RaList>
	);
};

export default List;
